export default __webpack_public_path__ + "static/temporary-savings-card-46c9f1fbf47d8aaf4b0f5e826fdf0971.png";